const primaryFontFamily = 'Kosugi';
const secondaryFontFamily = 'Roboto';

const primaryColor = 'rgba(242, 248, 248, 1)';
const secondaryColor = 'rgba(173, 179, 179, 1)';
const accentColor = 'rgba(115, 116, 116, 1)';
const borderColor = 'rgba(0, 0, 0, 0.3)';
const transparentColor = 'rgba(0, 0, 0, 0)';

export default {
  headline: {
    fontFamily: primaryFontFamily,
    color: primaryColor,
  },
  text: {
    fontFamily: secondaryFontFamily,
    color: primaryColor,
  },
  spacer: {
    color: transparentColor,
  },
  button: {
    fontFamily: secondaryFontFamily,
    color: primaryColor,
    borderColor: primaryColor,
    backgroundColor: secondaryColor,
  },
  rank: {
    baseColor: secondaryColor,
  },
  image: {
    backgroundColor: transparentColor,
  },
  field: {
    fontFamily: secondaryFontFamily,
    color: accentColor,
    borderColor: borderColor,
    backgroundColor: primaryColor,
  },
  social: {
    color: primaryColor,
  },
  survey: {
    color: primaryColor,
    borderColor: borderColor,
    backgroundColor: secondaryColor,
  },
  wheel: {
    fontFamily: primaryFontFamily,
    color: primaryColor,
    borderColor: borderColor,
    backgroundColor: secondaryColor,
    secondaryBackgroundColor: accentColor,
  },
  voucher: {
    fontFamily: secondaryFontFamily,
    color: primaryColor,
  },
  checkbox: {
    color: primaryColor,
    borderColor: secondaryColor,
    checkboxColor: primaryColor,
    backgroundColor: secondaryColor,
  },
};
